(function ($) {
  if (!$) return; // 🔥 prevents jQuery undefined crash

  $(document).ready(function () {

    // Open sidebar
    $('#openMenu').on('click', function () {
      $('.navbar-cst').addClass('active');
      $('#sidebarOverlay').addClass('active');
    });

    // Close sidebar
    $('.close-icon, #sidebarOverlay').on('click', function () {
      $('.navbar-cst').removeClass('active');
      $('#sidebarOverlay').removeClass('active');
    });

    // Slick sliders (check before init)


    // Counter animation
    /*var counters = $('.count-up');
    var speed = 2000;

    function countAnimation() {
      counters.each(function () {
        var $this = $(this);
        var target = parseInt($this.data('target'), 10) || 0;

        $({ countNum: 0 }).animate(
          { countNum: target },
          {
            duration: speed,
            step: function () {
              $this.text(Math.floor(this.countNum));
            },
            complete: function () {
              $this.text(target);
            }
          }
        );
      });
    }*/


    if (document.querySelector('.customer-reviews-section')) {
      new IntersectionObserver(function (entries, obs) {
        if (entries[0].isIntersecting) {
          countAnimation();
          obs.disconnect();
        }
      }, { threshold: 0.5 })
      .observe(document.querySelector('.customer-reviews-section'));
    }

    // Quantity buttons
    $('.quantity-btn').on('click', function (e) {
      e.preventDefault();
      var $input = $(this).siblings('.quantity-input');
      var val = parseInt($input.val(), 10) || 1;

      $input.val(
        $(this).data('action') === 'increase' ? val + 1 : Math.max(1, val - 1)
      );
    });

    // Counter buttons (0–20)
    $('.counter-btn-minus').on('click', function () {
      var el = $(this).siblings('.counter-value');
      el.text(Math.max(0, parseInt(el.text(), 10) - 1));
    });

    $('.counter-btn-plus').on('click', function () {
      var el = $(this).siblings('.counter-value');
      el.text(Math.min(20, parseInt(el.text(), 10) + 1));
    });

  });
})(window.jQuery);
